
export const zhTWTranslations = {
  'nav.home': '首頁',
  'nav.products': 'eSIM',
  'nav.contact': '聯絡我們',
  'product.customize': '定製',
  'product.price_oriented': '價格優先',
  'product.quality_oriented': '品質優先',
  'product.specs': '規格',
  'product.usage_days': '使用天數',
  'product.day': '天',
  'product.gb_per_day': '每天GB',
  'product.unlimited': '無限流量',
  'checkout.title': '結帳',
  'checkout.email': '電子郵件',
  'checkout.card_info': '卡片資訊',
  'checkout.card_number': '卡號',
  'checkout.expiry_date': '有效期',
  'checkout.cvc': '安全碼',
  'checkout.pay': '立即付款',
  'checkout.total': '總計',
  'checkout.tax': '含稅',
  'checkout.terms': '我同意服務條款',
  'footer.privacy': '隱私政策',
  'footer.terms': '服務條款',
  'footer.company': '關於我們',
  'footer.law': '特定商業交易法',
  'footer.copyright_tomaruyo': '© {year} TomaRuyo 版權所有。',
  // New translations
  'hero.title': '在日本使用的實惠eSIM',
  'hero.subtitle': '暢享舒適住宿和流暢的網路連接。使用我們的原創eSIM分享您的旅行記憶。',
  'hero.apa.title': '獲取在日本使用的實惠eSIM',
  'hero.apa.subtitle': '暢享舒適住宿和流暢的網路連接。通過APA酒店的原創數據套餐，讓商務和休閒更加便捷。',
  'products.title': 'eSIM套餐',
  'products.subtitle': '您可以選擇最喜歡的通訊套餐。從注重價格的經濟套餐到提供高品質通訊環境的優質套餐，我們都有提供。',
  'products.all': '全部',
  'products.price_focus': '注重價格',
  'products.quality': '注重品質',
  'products.choose_plan': '選擇此套餐',
  'products.selected': '已選擇',
  'customization.days': '天',
  'customization.back': '返回',
  'checkout.payment_info': '付款資訊',
  'checkout.secure_payment': '通過Stripe安全付款',
  'checkout.order_summary': '訂單摘要',
  'checkout.plan': '套餐：',
  'checkout.data_amount': '數據流量：',
  'checkout.network': '網路：',
  'checkout.usage_days': '使用天數：',
  'checkout.base_fee': '基本費用：',
  'checkout.days_fee': '每日費用：',
  'checkout.processing': '處理中...',
  'checkout.privacy_policy': '隱私政策',
  'checkout.agree': '我同意',
  'thankyou.title': '感謝您的訂購！',
  'thankyou.message': '我們已將確認郵件發送至 {email}。您將在24小時內收到您的eSIM資訊。',
  'thankyou.next_steps': '下一步',
  'thankyou.step1': '1. 檢查您的郵箱',
  'thankyou.step2': '2. 您將收到訂單確認郵件',
  'thankyou.step3': '3. eSIM資訊將在24小時內發送',
  'thankyou.back_to_home': '返回主頁',
  'thankyou.official_site': '前往Super Hotel官方網站',
  'thankyou.rb_official_site': '前往R&B Hotel官方網站',
  'thankyou.apa_official_site': '前往APA Hotel官方網站',
  'footer.links': '連結',
  'footer.official_website': '官方網站',
  'footer.hotel_list': '酒店列表',
  'footer.campaigns': '活動',
  'footer.stay_plans': '住宿套餐',
  'footer.information': '資訊',
  'footer.copyright': '© {year} Super Hotel Co., Ltd. 版權所有。',
  'footer.rb_copyright': '© {year} R&B Hotel. 版權所有。',
  'footer.apa_copyright': '© {year} APA HOTEL Co., Ltd. 版權所有。',
  'hero.choose_esim': '選擇eSIM',
  'hero.learn_more': '了解更多',
  
  // New translations for the updated eSIM Direct page
  'products.short_stay': '短期停留計劃',
  'products.long_stay': '長期停留計劃',
  'products.days': '天數',
  'products.data': '數據量',
  'products.price_label': '價格',
  'products.after_data': '流量用盡後',
  'products.action': '操作',
  'products.days_suffix': '天',
  'products.data_filter': '按數據量篩選',
  'products.days_filter': '按停留天數篩選',
  'products.all_data': '所有數據量',
  'products.all_days': '所有停留天數',
  'products.tax': '稅費',
  'products.no_products': '沒有符合條件的套餐',
  'products.coming_soon': '即將推出...',
  'products.premium_coming_soon': '高級套餐即將推出',
  'products.available': '可用eSIM套餐',
  'checkout.after_data': '數據用盡後',
  'checkout.delivery': '配送',
  'checkout.express_delivery': '30分鐘內郵件發送',
  'thankyou.choice_official_site': '前往Choice Hotels Japan官方網站',
  'hero.choice.title': '在日本使用的實惠eSIM',
  'hero.choice.subtitle': '暢享舒適住宿和流暢的網路連接。通過Choice Hotels Japan的原創數據套餐，讓商務和休閒更加便捷。',
  'hero.rembrandt.title': '在日本使用的實惠eSIM',
  'hero.rembrandt.subtitle': '暢享舒適住宿和流暢的網路連接。通過Rembrandt酒店的原創數據套餐，讓商務和休閒更加便捷。',
  'thankyou.rembrandt_official_site': '前往Rembrandt酒店官方網站',
  'footer.choice_copyright': '© {year} Choice Hotels Japan. 版權所有。',
  'footer.rembrandt_copyright': '© {year} Rembrandt Group. 版權所有。',
  'checkout.express_fee': '快遞費：',
  
  // Add new translations
  'checkout.tax_included': '（含稅）',
  'products.standard_1day': '標準1天套餐',
  'products.standard_3days': '標準3天套餐',
  'products.standard_7days': '標準7天套餐',
  'products.standard_15days': '標準15天套餐',
  'products.standard_30days': '標準30天套餐',
  'products.standard_60days': '標準60天套餐',
  'products.standard_90days': '標準90天套餐',
  'products.premium_1day': '高級1天套餐',
  'products.premium_3days': '高級3天套餐',
  'products.premium_7days': '高級7天套餐',
  'products.premium_15days': '高級15天套餐',
  'products.premium_30days': '高級30天套餐',
  'products.premium_60days': '高級60天套餐',
  'products.premium_90days': '高級90天套餐',
  'products.after_data_standard_1day': '速度降至128kbps',
  'products.after_data_standard_3days': '速度降至128kbps',
  'products.after_data_standard_7days': '速度降至128kbps',
  'products.after_data_standard_15days': '速度降至128kbps',
  'products.after_data_standard_30days': '速度降至128kbps',
  'products.after_data_standard_60days': '速度降至128kbps',
  'products.after_data_standard_90days': '速度降至128kbps',
  'products.after_data_premium_1day': '速度降至1Mbps',
  'products.after_data_premium_3days': '速度降至1Mbps',
  'products.after_data_premium_7days': '速度降至1Mbps',
  'products.after_data_premium_15days': '速度降至1Mbps',
  'products.after_data_premium_30days': '速度降至1Mbps',
  'products.after_data_premium_60days': '速度降至1Mbps',
  'products.after_data_premium_90days': '速度降至1Mbps',
  
  // Add new translations for express delivery
  'checkout.express_delivery_message': '加急服務：我們將在30分鐘內通過電子郵件發送eSIM',
  'checkout.standard_delivery_message': '我們將在24小時內通過電子郵件發送eSIM',
  'checkout.express_delivery_option': '30分鐘內接收eSIM（+¥550）',
  
  // Add translations for customer info section
  'checkout.customer_info': '客戶資訊',
  'checkout.basic_info': '基本資訊',
  'checkout.additional_info': '附加資訊（可選）',
  'checkout.name': '姓名',
  'checkout.name_placeholder': '例如：張三',
  'checkout.phone': '電話號碼',
  'checkout.phone_placeholder': '例如：09012345678',
  'checkout.country': '國籍/居住國',
  'checkout.country_placeholder': '請選擇國家',
  'checkout.device_info': '設備資訊',
  'checkout.device_info_placeholder': '請選擇您的設備',
  'checkout.travel_purpose': '旅行目的',
  'checkout.travel_purpose_placeholder': '請選擇您的目的',
  'checkout.marketing_consent': '我同意通過電子郵件接收客戶支援、活動和促銷資訊',
  'checkout.support_info': '用於客戶支援目的。',
  
  // Payment button translations
  'checkout.complete_payment': '完成付款',
  'checkout.back': '返回',
  'checkout.tourism': '旅遊',
  'checkout.business': '商務',
  'checkout.family': '家庭訪問',
  'checkout.education': '留學/教育',
  'checkout.other': '其他',
  
  // Add new translations for checkout section
  'checkout.proceed_to_order': '前往訂單',
  'checkout.selected_product': '已選商品',
  'checkout.price': '價格',
  'checkout.proceed_to_checkout': '進入結帳流程',
  'checkout.select_product': '請選擇商品',
  
  // Add missing proceed to payment key
  'checkout.proceed_to_payment': '前往付款',
  
  // Add new UI element translations
  'checkout.payment': '付款資訊',
  'checkout.cardholder_name': '持卡人姓名',
  'checkout.reload_form': '重新載入表單',
  'admin.confirm_purchase': '確認購買',
  'admin.update_data': '更新數據',
  
  // Loading translations
  'products.loading': '載入中...',
  'error.title': '發生錯誤',
  'error.try_again_later': '請稍後再試',
  'error.retry': '重試',
};
